import {baseURL, imageBaseURL, audioBaseURL, videoBaseURL, lerneinheitenOverviewPageID,
    quizParsingToken_Frage,
    quizParsingToken_Antworten,
    quizParsingToken_antwort,
    quizParsingToken_Korrekt,
    quizParsingToken_dnd,
    quizParsingToken_dno,
    quizParsingToken_drags,
    quizParsingToken_drops,
    quizParsingToken_dragdropUnit,
    quizParsingToken_message,
    quizParsingToken_correct,
    quizParsingToken_wrong,
    quizParsingToken_height,
    categoryToIconMapper
} from "../../../constants"

import {
    pruneTypo3AddedTags,
    removeSpecialChars,

} from "./htmlAdjustments"
import {containsOnlyNumbers } from "../../../utils/functions" 


export function parseMultipleChoiceQuiz(rawString){
    rawString = pruneTypo3AddedTags(rawString)
    /*
    Delimiter Tokens:                                Explanation:
    quizParsingToken_Frage = "_F_"                  indicates the question, which follows immideately after this token.
    quizParsingToken_Antworten = "_A_"              ends the question and indicates start of the block of several answers.
    quizParsingToken_antwort = "_a_"                Every single answer starts with this token.
    quizParsingToken_Korrekt = "_K_"                Ends the actual answers and is followed by a sequence of numbers indicating the indeces of correct answers.

    quizParsingToken_message = "_msg_"              Starts the message block.
     quizParsingToken_correct = "_+_"               Followed by message to be shown if quiz solved correctly.
     quizParsingToken_wrong = "_-_"                 Followed by string to be shown if quiz is not solved correctly.

     quizParsingToken_height = "_H_"                Optionally provides a height of the element in pixels.
    */
   // extract height of card and remove from rawString
    let height = 500 // default height
    if(rawString.includes(quizParsingToken_height)){
        const heightString = rawString.split(quizParsingToken_height)[1]
        rawString = rawString.replaceAll(quizParsingToken_height, "")
        rawString = rawString.replaceAll(heightString, "")
        height = parseInt(heightString)

    }
    if(rawString.includes(quizParsingToken_Frage) && rawString.includes(quizParsingToken_Antworten) && rawString.includes(quizParsingToken_antwort) && rawString.includes(quizParsingToken_Korrekt)){
        const question = rawString.split(quizParsingToken_Frage)[1].split(quizParsingToken_Antworten)[0]  // between _F_ and _A_
        let answers = rawString.split(quizParsingToken_Antworten)[1].split(quizParsingToken_Korrekt)[0].substring(quizParsingToken_antwort.length + 1)
        answers = answers.split(quizParsingToken_antwort)
        let correctAnswerIndecesRaw = rawString.split(quizParsingToken_Korrekt)[1]
        if(correctAnswerIndecesRaw.includes(quizParsingToken_message)){
            correctAnswerIndecesRaw = correctAnswerIndecesRaw.split(quizParsingToken_message)[0]
        }
        correctAnswerIndecesRaw = correctAnswerIndecesRaw.replaceAll(" ", "")
        let correctAnswerIndeces = []        
        if(!containsOnlyNumbers(correctAnswerIndecesRaw)){
            const stringWithoutComma = correctAnswerIndecesRaw.replaceAll(",", "")
            if(correctAnswerIndecesRaw.includes(",") && containsOnlyNumbers(stringWithoutComma)){
                // only contains numbers and ","
                correctAnswerIndeces = correctAnswerIndecesRaw.split(",")
            } else {
                // Error: some other string than number or ","
                console.error("Faulty Quiz Syntax!")
                console.log(correctAnswerIndecesRaw)
                correctAnswerIndeces.push("0")
            }
        } else {
            // assume only one number
            correctAnswerIndeces.push(correctAnswerIndecesRaw)  
        }
        let messagesString = rawString.split(quizParsingToken_message)[1]
        let correctMsg = ""
        let wrongMsg = ""
        if(messagesString.includes(quizParsingToken_correct) && messagesString.includes(quizParsingToken_wrong) ){
            correctMsg = messagesString.split(quizParsingToken_correct)[1].split(quizParsingToken_wrong)[0]
            wrongMsg = messagesString.split(quizParsingToken_wrong)[1].split(quizParsingToken_correct)[0]
        }
        const result =  {
            question,
            answers,
            correctAnswerIndeces: correctAnswerIndeces.map(i => {return parseInt(i) - 1}), // Index in Typo3 Element starts with 1
            correctMsg,
            wrongMsg,
            height: height && height
        }
        return  result
    } else {
        console.log("ERROR, rawString doesnt contain _A_, _F_ etc", rawString)
        return null
    }
}


export function parseDragnDropQuiz(rawString){
    rawString = pruneTypo3AddedTags(rawString)
    /*
        Delimiter Tokens
     quizParsingToken_dnd = "_dnd_"
     quizParsingToken_drags = "_drag_"
     quizParsingToken_drops = "_drop_"
     quizParsingToken_dragdropUnit = "_d_"
     quizParsingToken_message = "_msg_"
     quizParsingToken_correct = "_+_"
     quizParsingToken_wrong = "_-_"
    */
    if(rawString.includes(quizParsingToken_dnd) && rawString.includes(quizParsingToken_drags) && rawString.includes(quizParsingToken_drops) 
    && rawString.includes(quizParsingToken_dragdropUnit) && rawString.includes(quizParsingToken_message)){
        const title = rawString.split(quizParsingToken_dnd)[1].split(quizParsingToken_drags)[0]  // between _dnd_ and _drag_
        let drags = rawString.split(quizParsingToken_drags)[1].split(quizParsingToken_drops)[0].substring(quizParsingToken_dragdropUnit.length + 2)  // remove first "_d_" //// WHY 2 instead of 1?????? 
        drags = drags.split(quizParsingToken_dragdropUnit)
        let drops = rawString.split(quizParsingToken_drops)[1].split(quizParsingToken_message)[0].substring(quizParsingToken_dragdropUnit.length + 1)  // remove first "_d_"
        drops = drops.split(quizParsingToken_dragdropUnit)
        let messagesString = rawString.split(quizParsingToken_message)[1]
        let correctAnswer = ""
        let wrongAnswer = ""
        if(messagesString.includes(quizParsingToken_correct) && messagesString.includes(quizParsingToken_wrong) ){
            correctAnswer = messagesString.split(quizParsingToken_correct)[1].split(quizParsingToken_wrong)[0]
            wrongAnswer = messagesString.split(quizParsingToken_wrong)[1].split(quizParsingToken_correct)[0]
        }
        const result =  {
            title: removeSpecialChars(title),
            drags: drags,
            drops: drops, // drops.map(d => removeSpecialChars(d)),
            correctAnswer: removeSpecialChars(correctAnswer),
            wrongAnswer: removeSpecialChars(wrongAnswer),
        }
        return  result
    } else {
        console.log("ERROR, rawString doesnt contain _dnd_, _drag_ etc", rawString)
        return null
    }
}


export function parseDragnOrderQuiz(rawString){
    rawString = pruneTypo3AddedTags(rawString)
    /*
        Delimiter Tokens
     quizParsingToken_dno = "_dno_"
     quizParsingToken_drags = "_drag_"
     quizParsingToken_dragdropUnit = "_d_"
     quizParsingToken_message = "_msg_"
     quizParsingToken_correct = "_+_"
     quizParsingToken_wrong = "_-_"
    */
    if(rawString.includes(quizParsingToken_dno) && rawString.includes(quizParsingToken_drags) 
    && rawString.includes(quizParsingToken_dragdropUnit) && rawString.includes(quizParsingToken_message)){
        const title = rawString.split(quizParsingToken_dno)[1].split(quizParsingToken_drags)[0]  // between _dno_ and _drag_
        let drags = rawString.split(quizParsingToken_drags)[1].split(quizParsingToken_message)[0].substring(quizParsingToken_dragdropUnit.length + 2)  // remove first "_d_" //// WHY 2 instead of 1?????? 
        drags = drags.split(quizParsingToken_dragdropUnit)
        let messagesString = rawString.split(quizParsingToken_message)[1]
        let correctAnswer = ""
        let wrongAnswer = ""
        if(messagesString.includes(quizParsingToken_correct) && messagesString.includes(quizParsingToken_wrong) ){
            correctAnswer = messagesString.split(quizParsingToken_correct)[1].split(quizParsingToken_wrong)[0]
            wrongAnswer = messagesString.split(quizParsingToken_wrong)[1].split(quizParsingToken_correct)[0]
        }
        const result =  {
            title: removeSpecialChars(title),
            drags: drags,
            correctAnswer: removeSpecialChars(correctAnswer),
            wrongAnswer: removeSpecialChars(wrongAnswer),
        }
        return  result
    } else {
        console.log("ERROR, rawString doesnt contain _dno_, _drag_ etc", rawString)
        return null
    }
}

